import axios from 'axios';
import { useState } from 'react';

import { regenerateTabelByUser } from '~modules/tabel/api';
import { UserDto } from '~modules/user/model';
import DateIntervalPicker from '~shared/ui/date-interval-picker/date-interval-picker';
import Modal from '~shared/ui/modal/modal';
import { toastError, toastSuccess } from '~shared/ui/toast/toast-helper';

import { UserSelect } from '../../user-select/user-select';

interface RegenerateByUserModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const RegenerateByUserModal = ({ isOpen, onClose, onSuccess }: RegenerateByUserModalProps) => {
	const [user, setUser] = useState<UserDto | null>(null);
	const [startDate, setStartDate] = useState<Date | undefined>();
	const [endDate, setEndDate] = useState<Date | undefined>();
	const [pending, setPending] = useState(false);

	const reset = () => {
		setUser(null);
		setStartDate(undefined);
		setEndDate(undefined);
	};

	const handleClose = () => {
		reset();
		onClose();
	};

	const handleOk = async () => {
		if (!user || !startDate || !endDate) return;
		setPending(true);
		try {
			await regenerateTabelByUser(user.id, startDate, endDate);
			toastSuccess('Период пересобирается');
			reset();
			onClose();
			onSuccess?.();
		} catch (err) {
			if (axios.isAxiosError(err)) {
				toastError(err.response?.data?.message ?? 'Ошибка пересборки');
			} else {
				toastError('Ошибка пересборки');
			}
		} finally {
			setPending(false);
		}
	};

	const okIsDisable = !user || !startDate || !endDate || pending;

	const stopEscPropagation = (e: React.KeyboardEvent) => {
		if (e.key === 'Escape') {
			e.stopPropagation();
			e.nativeEvent.stopImmediatePropagation();
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose} onOk={handleOk} okIsDisable={okIsDisable}>
			<div
				style={{ display: 'flex', flexDirection: 'column', gap: '20px', minWidth: '640px', minHeight: 'auto' }}
			>
				<h3 style={{ margin: 0 }}>Пересобрать табель для сотрудника</h3>
				<div onKeyDown={stopEscPropagation}>
					<label style={{ display: 'block', marginBottom: '6px' }}>Сотрудник</label>
					<UserSelect
						value={user ?? []}
						isMulti={false}
						ignoreSections={false}
						placeholder="Выберите сотрудника..."
						onChange={value => setUser(value as UserDto)}
					/>
				</div>
				<div onKeyDown={stopEscPropagation}>
					<label style={{ display: 'block', marginBottom: '6px' }}>Период</label>
					<DateIntervalPicker
						startDate={startDate}
						endDate={endDate}
						onChange={(s, e) => {
							setStartDate(s ?? undefined);
							setEndDate(e ?? undefined);
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};
